<template>
  <div
    class="
      mt-6
      px-5
      py-4
      flex
      max-w-xl
      font-normal
      text-sm text-gray-900
      rounded-lg
      shadow-md
      bg-vice-light-beige
      border border-vice-yellow
      dark:bg-gray-800
      dark:text-red-400
      dark:border-red-800
    "
    role="alert"
  >
    <ExclamationIcon class="w-7 h-7 mr-3" />
    <div class="text-left leading-7">
      <span class="font-semibold text-black">Speakers changed</span>
      <p class="leading-5 text-gray-600">
        Your speakers switched from your preferred device
        <span class="font-semibold">{{ lastSpkLabel }}</span>
        to
        <span class="font-semibold">{{ newSpkLabel }}.</span>
      </p>
      <p class="leading-7 text-gray-600">
        Audio is still active, but this may affect sound quality.
      </p>
      <div class="flex items-center gap-3 mt-2 -ml-2 font-semibold">
        <!-- Switch back button -->
        <ViceButton
          v-if="lastSpkAvailable"
          @click="switchBack"
          data-cy="switch-spk-back-button"
          class="font-bold px-4"
          small
        >
          <CircledArrowIcon class="w-4 h-4 mr-1" />
          Switch back to preferred device
        </ViceButton>

        <!-- Keep current button -->
        <ViceButton
          data-cy="keep-spk-current-button"
          class="font-bold px-4"
          @click="closeAlert"
          small
          white
        >
          Keep current device
        </ViceButton>
      </div>
    </div>

    <button
      type="button"
      class="ms-auto -mx-1 inline-flex items-center justify-center h-6 w-6 ml-auto"
      aria-label="Close"
      @click="closeAlert"
    >
      <span class="sr-only">Close</span>
      <CrossedBlackIcon />
    </button>
  </div>
</template>
<script>
import { computed } from 'vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import ExclamationIcon from '@/Components/Icons/ExclamationIcon.vue';
import CircledArrowIcon from '@/Components/Icons/CircledArrowIcon.vue';
import CrossedBlackIcon from '@/Components/Icons/CrossedBlackIcon.vue';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';
import { CAMERA_TYPES, DEVICE_NAME } from '@/Utils/vice-constants';

export default {
  name: 'SpeakerSwitchedAlert',
  components: {
    ViceButton,
    ExclamationIcon,
    CircledArrowIcon,
    CrossedBlackIcon,
  },
  setup() {
    const multiCameraStore = useLocalStreamingDevicesStore();
    const lastSpkLabel = multiCameraStore.lastSpkLabel;

    const lastSpkAvailable = computed(() =>
      multiCameraStore.mediaDevices[DEVICE_NAME.SPEAKERS]?.find(
        (device) => device.label === lastSpkLabel,
      ),
    );

    const newSpkLabel = computed(() => multiCameraStore.getSelectedActualSpeakersLabel());

    const switchBack = () => {
      multiCameraStore.chooseMediaSource(
        CAMERA_TYPES.INTERNAL_WEBCAM,
        DEVICE_NAME.SPEAKERS,
        lastSpkAvailable.value,
      );

      closeAlert();
    };

    const closeAlert = () => {
      multiCameraStore.showSpkSwitchedAlert = false;
    };

    return {
      newSpkLabel,
      lastSpkLabel,
      lastSpkAvailable,
      closeAlert,
      switchBack,
    };
  },
};
</script>
